import medal from '@/assets/ic_medal.svg'
import edit from '@/assets/ic_edit.svg'
import file from '@/assets/ic_file-text.svg'
import arrow from '@/assets/ic_corner-up-right.svg'
import userCheck from '@/assets/ic_profile-check.svg'
import spainFlag from '@/assets/ic_spanish.svg'
import peruFlag from '@/assets/ic_peru.svg'
import mexicoFlag from '@/assets/ic_mexico.svg'
import colombiaFlag from '@/assets/ic_colombia.svg'
import argentinaFlag from '@/assets/ic_argentina.svg'
import usFlag from '@/assets/ic_us.svg'
import uruguayFlag from '@/assets/ic_uruguay.svg'
import otherFlag from '@/assets/ic_other.svg'
import screen1 from '@/assets/screen1.png'
import screen2 from '@/assets/screen2.png'
import screen3 from '@/assets/screen3.png'
import screen4 from '@/assets/screen4.png'
import screen5 from '@/assets/screen5.png'
import screen6 from '@/assets/screen6.png'
import screen7 from '@/assets/screen7.png'
import checkIcon from '@/assets/ic_check_base.svg'
import crossIcon from '@/assets/ic_circle_cross_red.svg'
import clockIcon from '@/assets/ic_clock.svg'

import { stringArrayToObject } from './array'

export const feedbackOptions = [
  {
    status: false,
    icon: medal,
    text: 'presentationTab.innovation'
  },
  {
    status: false,
    icon: edit,
    text: 'presentationTab.applicability'
  },
  {
    status: false,
    icon: file,
    text: 'presentationTab.structure'
  },
  {
    status: false,
    icon: arrow,
    text: 'presentationTab.teachingGuide'
  },
  {
    status: false,
    icon: userCheck,
    text: 'presentationTab.author'
  }
]

export const profileTabs = ['myProfile', 'schoolGroup', 'school']

export const tabTitle = 'Kimple'

export const dateFormat = 'DD · MM · YYYY'
export const folderNameMaxLength = 50

export const timeRangesOptions = [
  { label: 'stats.timeRangeOptions.last30days', value: 1 },
  { label: 'stats.timeRangeOptions.lastTrimester', value: 3 },
  { label: 'stats.timeRangeOptions.lastSemester', value: 6 },
  { label: 'stats.timeRangeOptions.lastYear', value: 12 }
]

export const abilities = [
  { label: 'stats.skills.problemResolution', name: 'Resolución de problemas', color: '#D64393' },
  { label: 'stats.skills.criticalThinking', name: 'Pensamiento crítico', color: '#FA8A84' },
  { label: 'stats.skills.teamwork', name: 'Trabajo en equipo', color: '#B6E23B' },
  { label: 'stats.skills.flexibility', name: 'Flexibilidad', color: '#46BB61' },
  { label: 'stats.skills.resilience', name: 'Resiliencia', color: '#7677E6' },
  { label: 'stats.skills.analisis', name: 'Análisis', color: '#69DBD8' },
  { label: 'stats.skills.creativity', name: 'Creatividad', color: '#A162FF' },
  { label: 'stats.skills.effectiveCommunication', name: 'Comunicación', color: '#FF566E' },
  { label: 'stats.skills.commitment', name: 'Compromiso y responsabilidad', color: '#FF985A' },
  { label: 'stats.skills.perseverance', name: 'Perseverancia', color: '#FFD83E' },
  { label: 'stats.skills.leadership', name: 'Liderazgo', color: '#65D075' },
  { label: 'stats.skills.initiative', name: 'Iniciativa', color: '#6295FF' }
]

export const methodologies = [
  { value: 1, name: 'Workshop', color: '#A6C2FF' },
  { value: 2, name: 'Project', color: '#6295FF' },
  { value: 4, name: 'DidacticSequence', color: '#DCE7FF' },
  { value: 5, name: 'Exercise', color: '#325EBC' }
]

export const categories = [
  { label: 'Pensamiento computacional' },
  { label: 'Ciudadanía global' },
  { label: 'Espíritu emprendedor' }
]

export const categoriesInfo = [
  {
    id: 1,
    name: 'computationalThinking',
    color: '#FFD83E'
  },
  {
    id: 2,
    name: 'globalCitizenship',
    color: '#FF566E'
  },
  {
    id: 3,
    name: 'entrepreneurialSpirit',
    color: '#6295FF'
  }
]

// TODO: Instead of using this object of objects using the the categoryId as a key,
// use categoriesInfo using the find method to find the id.
export const categoriesColors = {
  1: {
    name: 'Pensamiento computacional',
    color: '#FFD83E',
    imageName: 'ilus_pensamiento'
  },
  2: {
    name: 'Ciudadanía global',
    color: '#FF566E',
    imageName: 'ilus_ciudadania'
  },
  3: {
    name: 'Espíritu emprendedor',
    color: '#6295FF',
    imageName: 'ilus_emprendimiento'
  }
}

export const educationalProgramStatus = {
  purchased: 1,
  notPurchased: 2
}

export const educationalProgramLanguageStatus = {
  approved: 1,
  comingSoon: 2,
  hidden: 3
}

export const sectionsIndex = [
  'about',
  'trigger',
  'image-trigger',
  'objectives',
  'class',
  'organization',
  'necessaryMaterials',
  'assignament',
  'start',
  'development',
  'closure',
  'valuation',
  'downloadableContent'
]

export const teacherClassesIndex = [
  'startSection',
  'developmentSection',
  'closureSection',
  'valuationSection',
  'necessaryDownloadableMaterials'
]

export const studentClassesIndex = [
  'statement',
  'necessaryDownloadableMaterials'
]

export const teacherTriggerIndex = [
  'media',
  'classPlanDescription',
  'pedagogicalGoal'
]

export const studentTriggerIndex = [
  'media',
  'studentPedagogicalGoal',
  'rhetoricalQuestion'
]

export const requestInformationCategories = [
  {
    id: 1,
    name: 'innovation',
    active: false
  },
  {
    id: 2,
    name: 'thematic',
    active: false
  },
  {
    id: 3,
    name: 'author',
    active: false
  }
]

export const categoryOptions = [
  { label: 'categories.programming', value: 1 },
  { label: 'categories.citizenship', value: 2 },
  { label: 'categories.enteprenourship', value: 3 }
]

export const emptyGraphic = [{ category: '', value: 100 }]

export const resourcesMoreValuedColors = ['#69DBD8', '#B6E23B', '#46BB61', '#D64393', '#FA8A84']

export const approachByCategoryColors = ['#6295FF', '#FF566E', '#FFD83E']

export const emptyPieColor = '#F1F2F6'

export const aspectResourceOptions = [
  {
    id: 0,
    value: '-',
    category: 'innovation'
  },
  {
    id: 1,
    value: '-',
    category: 'applicability'
  },
  {
    id: 2,
    value: '-',
    category: 'methodology'
  },
  {
    id: 3,
    value: '-',
    category: 'teacherGuide'
  },
  {
    id: 4,
    value: '-',
    category: 'author'
  }
]

export const approachOptions = [
  {
    id: 0,
    value: '-',
    category: 'category.enteprenourship'
  },
  {
    id: 1,
    value: '-',
    category: 'category.citizenship'
  },
  {
    id: 2,
    value: '-',
    category: 'category.programming'
  }
]

export const firstPage = 0

export const nextPage = 1

export const prevPage = -1

export const pagesOffset = 2

export const defaultPageSize = 4

export const defaultProgramsPageSize = 6

export const countriesTelephoneFormat = [
  {
    id: 1,
    name: 'argentina',
    flagIcon: argentinaFlag,
    example: '9 11 11234567',
    code: '+54'
  },
  {
    id: 2,
    name: 'spain',
    flagIcon: spainFlag,
    example: '612 34 56 78',
    code: '+34'
  },
  {
    id: 3,
    name: 'unitedStates',
    flagIcon: usFlag,
    example: '201 5550123',
    code: '+1'
  },
  {
    id: 4,
    name: 'peru',
    flagIcon: peruFlag,
    example: '912 345 678',
    code: '+51'
  },
  {
    id: 5,
    name: 'uruguay',
    flagIcon: uruguayFlag,
    example: '2204 5199',
    code: '+598'
  },
  {
    id: 6,
    name: 'mexico',
    example: '55 1234 5678',
    flagIcon: mexicoFlag,
    code: '+52'
  },
  {
    id: 7,
    name: 'colombia',
    example: '300 3482592',
    flagIcon: colombiaFlag,
    code: '+57'
  },
  {
    id: 8,
    name: 'other',
    example: '2204 5199',
    flagIcon: otherFlag,
    code: ''
  }
]

export const otherCodeCountry = countriesTelephoneFormat.find(country => country.name === 'other')

export const maxTelephoneLength = 20

export const countryCodeSeparator = ' '

export const tabMyProfile = 'myProfile'

export const tabSchool = 'school'

export const tabSchoolsNetwork = 'schoolsNetwork'

export const firstElement = 0

export const secondElement = 1

export const avatarListLimit = 9

export const userPrimaryRoles = {
  kimple: 'Kimple',
  admin: 'Admin',
  manager: 'Manager',
  teacher: 'Teacher',
  trial: 'Trial'
}

export const userSecondaryRoles = {
  author: 'Author',
  approvingAuthor: 'ApprovingAuthor'
}

export const profileFields = stringArrayToObject(['bio', 'cellPhoneNumber', 'educationalLevels', 'subjectsLabel'])

export const profileFieldsByRole = {
  [userPrimaryRoles.teacher]: [profileFields.bio, profileFields.cellPhoneNumber, profileFields.educationalLevels, profileFields.subjectsLabel],
  [userPrimaryRoles.manager]: [profileFields.bio, profileFields.cellPhoneNumber],
  [userPrimaryRoles.admin]: [profileFields.bio, profileFields.cellPhoneNumber],
  [userPrimaryRoles.trial]: [profileFields.bio, profileFields.cellPhoneNumber, profileFields.educationalLevels],
  [userPrimaryRoles.kimple]: []
}

export const studentsRange = [
  'Menos de 300 estudiantes',
  'Entre 300 y 500 estudiantes',
  'Entre 501 y 1000 estudiantes',
  'Más de 1000 estudiantes'
].map((range, idx) => ({ id: idx + 1, value: idx + 1, label: range }))

export const charactersLimit = 400

export const uploadFileBase = {
  content: '',
  fileType: ''
}
export const managersID = 1

export const teamID = 2

export const maxFileSize = 2097152 // 2MB

export const teamMembersStatus = {
  removed: 'removed',
  confirmed: 'confirmed',
  pending: 'pending',
  canceled: 'canceled'
}

export const teamMembersStatusIds = {
  none: 0,
  confirmed: 1,
  canceled: 2,
  pending: 3
}

export const folderPermissions = [
  {
    id: 0,
    name: 'read'
  },
  {
    id: 1,
    name: 'edit'
  }
]

export const fullNameMaxLength = 50

export const networkNameMaxLength = 120

export const schoolNameMaxLength = 120

export const cueMaxLength = 9

export const schoolAddressMaxLength = 70

export const skills = [
  { label: 'problemResolution', color: '#D64393' },
  { label: 'flexibility', color: '#46BB61' },
  { label: 'criticalThinking', color: '#FA8A84' },
  { label: 'initiative', color: '#6295FF' },
  { label: 'perseverance', color: '#FFD83E' },
  { label: 'creativity', color: '#A162FF' },
  { label: 'leadership', color: '#65D075' },
  { label: 'effectiveCommunication', color: '#FF566E' },
  { label: 'curiosity', color: '#69DBD8' },
  { label: 'commitment', color: '#FF985A' },
  { label: 'resilience', color: '#7677E6' },
  { label: 'teamwork', color: '#B6E23B' }
]

export const managerModalOptions = {
  add: 'Added',
  removed: 'Removed',
  both: 'changesSaved',
  teachers: 'teachers',
  managers: 'managers',
  members: 'members'
}

export const screensCarousel = [
  { id: 1, image: screen1, alt: 'feed-image', text: 'screen1' },
  { id: 2, image: screen2, alt: 'filters-image', text: 'screen2' },
  { id: 3, image: screen3, alt: 'resource-image', text: 'screen3' },
  { id: 4, image: screen4, alt: 'teacher-image', text: 'screen4' },
  { id: 5, image: screen5, alt: 'teacher-image', text: 'screen5' },
  { id: 5, image: screen6, alt: 'teacher-image', text: 'screen6' },
  { id: 5, image: screen7, alt: 'teacher-image', text: 'screen7' }
]

export const validatorAsyncFields = {
  email: 'email',
  address: 'address'
}

export const baseTrialUser = {
  cellPhoneNumber: '',
  fullName: '',
  email: '',
  position: '',
  password: '',
  confirmPassword: '',
  repeatEmail: '',
  emailConfirmed: false,
  userId: '',
  school: {
    name: '',
    address: '',
    impartedLevels: [],
    city: '',
    country: '',
    countryISO2: '',
    addressLatitude: 0,
    addressLongitude: 0
  }
}

export const baseNewUserWithoutSchool = {
  userVO: {
    cellPhoneNumber: '',
    fullName: '',
    email: '',
    schoolName: '',
    schoolId: '',
    position: {
      position: '',
      positionId: 1
    }
  },
  password: '',
  confirmPassword: ''
}

export const baseNewUser = {
  ...baseNewUserWithoutSchool,
  schoolName: '',
  schoolAddress: ''
}

export const expiredTokenCode = 409

export const maxInvitations = 4

export const mobileBreak = 900

export const checked = 'checked'

export const notChecked = 'notChecked'

export const userPermissions = {
  read: 'Read',
  edit: 'Edit',
  owner: 'Owner'
}

export const feedOnboarding = 'feedOnboarding'

export const positiveReviewMinimumStars = 4

export const reviewCommentMaxLength = 500

export const licenses = {
  freemium: 1,
  programFee: 2,
  campus: 3,
  custom: 4
}

export const complementaryLicenses = {
  krea: 1,
  whiteLabel: 2
}

export const authorImages = {
  kimple: 'https://kimple-images-prod.s3.amazonaws.com/authors/ic_isologo.png',
  ypd: 'https://kimple-images-prod.s3.amazonaws.com/authors/ypd/avatar.png',
  wll: 'https://kimple-images-prod.s3.amazonaws.com/authors/wll.png',
  ecohouse: 'https://kimple-images-prod.s3.amazonaws.com/authors/Eco+House+(circular).png',
  newtral: 'https://kimple-images-prod.s3.amazonaws.com/authors/Newtral+Educacio%CC%81n.png',
  mentesInquietas: 'https://kimple-images-prod.s3.amazonaws.com/authors/Mentes-Inquietas/mentes-inquietas.jpeg',
  lab: 'https://kimple-images-prod.s3.amazonaws.com/authors/possible_lab_logo.png',
  garaje: 'https://kimple-images-prod.s3.amazonaws.com/authors/Garaje.jpg',
  fad: 'https://kimple-images-prod.s3.amazonaws.com/authors/Logo-Fad.jpg',
  laferrereAndFernandezCisneros: 'https://kimple-images-prod.s3.amazonaws.com/authors/Ferrere_Cisneros_Logo.jpeg',
  holocaustMemorialDayTrust: 'https://kimple-images-prod.s3.amazonaws.com/authors/holocaust_memorial_day_logo.jpg',
  standUpEducationAgainstDiscrimination: 'https://kimple-images-prod.s3.amazonaws.com/authors/stand_up_logo.png',
  LicSilviaHurrell: 'https://kimple-images-prod.s3.amazonaws.com/authors/Silvia_Hurrell_logo.jpg',
  InspiringFC: 'https://kimple-images-prod.s3.amazonaws.com/authors/Inspiring_FC_logo.png',
  earthEcho: 'https://kimple-images-prod.s3.amazonaws.com/069a58e5-08b7-4b73-8e90-463c98b4af90.png'
}

export const kreaNewResourceTabs = [
  {
    step: 1,
    label: 'generalInfo'
  },
  {
    step: 2,
    label: 'introductoryContent'
  },
  {
    step: 3,
    label: 'triggers'
  },
  {
    step: 4,
    label: 'classes'
  }
]

export const lectureOrganization = [
  { label: 'group', id: 1 },
  { label: 'individual', id: 2 },
  { label: 'smallgroups', id: 3 }
]

export const classPlans = [
  { label: 'row', id: 1 },
  { label: 'group', id: 2 },
  { label: 'circle', id: 3 },
  { label: 'halfCircle', id: 4 }
]

export const classNecessaryMaterialsTypes = {
  student: 1,
  teacher: 2
}

export const classMaterialsTypes = {
  electronic: 1,
  physic: 2,
  downloadable: 3
}

export const triggersFormSlides = {
  teacher: 0,
  student: 1
}

export const classFormSlides = {
  teacher: 0,
  student: 1
}

export const kreaNewResourceSteps = {
  generalInfo: 1,
  introductoryContent: 2,
  triggers: 3,
  classes: 4
}

export const presentationVideosUrl = {
  ES_AR: 'https://player.vimeo.com/video/425965496',
  ES_CA: 'https://player.vimeo.com/video/675794112',
  EN_US: 'https://player.vimeo.com/video/675794071'
}

export const folderOrigins = {
  createdByMe: 1,
  copiedFromKimpleFolder: 2
}

export const complementaryLicenseStatusCodes = {
  active: 1,
  suspended: 2,
  cancelled: 3
}

export const resourceMediaTypes = {
  video: 1,
  image: 2
}

export const rolesIds = {
  none: 0,
  admin: 1,
  manager: 2,
  teacher: 3
}

export const secondaryRolesIds = {
  author: 1,
  approvingAuthor: 2
}

export const rolesOptions = [
  { label: 'manager', value: rolesIds.manager },
  { label: 'teacher', value: rolesIds.teacher }
]

export const secondaryRolesOptions = [
  { label: 'author', value: secondaryRolesIds.author },
  { label: 'approvingAuthor', value: secondaryRolesIds.approvingAuthor }
]

export const teamStatusOptions = [
  { label: 'confirmed', value: teamMembersStatusIds.confirmed },
  { label: 'canceled', value: teamMembersStatusIds.canceled },
  { label: 'pending', value: teamMembersStatusIds.pending }
]

export const teamStatusStyles = [
  { class: 'green', icon: checkIcon, value: teamMembersStatus.confirmed },
  { class: 'red', icon: crossIcon, value: teamMembersStatus.canceled },
  { class: 'dark-gray', icon: clockIcon, value: teamMembersStatus.pending }
]

export const educationalLevels = {
  primary: 'primary',
  secondary: 'secondary'
}

export const teamListDefaultPageSize = 10

export const paginatedTableSizes = [
  { value: 10 },
  { value: 20 },
  { value: 30 }
]

export const contentType = {
  program: 1,
  project: 2
}
